import React from "react";

function Footer() {
  return (
    <div className="h-20 bg-gray-600 r">
      <h6 className="text-center pt-8 text-white">
        All rights reserved &copy; Irshath
      </h6>
    </div>
  );
}

export default Footer;
